import {
  GET_ENRICHED_SCHEMAS,
  GET_PAGINATED_ENRICHED_SCHEMAS,
  GETTING_ENRICHED_SCHEMAS_SUCCEEDED,
  GETTING_PAGINATED_ENRICHED_SCHEMAS_SUCCEEDED,
  GETTING_ENRICHED_SCHEMAS_FAILED,
  GETTING_PAGINATED_ENRICHED_SCHEMAS_FAILED,
  GETTING_ENRICHED_SCHEMA_KEYS_SUCCEEDED,
  GETTING_ENRICHED_SCHEMA_KEYS_FAILED,
  GETTING_ENRICHED_SCHEMA_SUCCEEDED,
  GETTING_ENRICHED_SCHEMA_FAILED,
  CREATE_ENRICHED_SCHEMA,
  CREATING_ENRICHED_SCHEMA_SUCCEEDED,
  CREATING_ENRICHED_SCHEMA_FAILED,
  UPDATE_ENRICHED_SCHEMA,
  UPDATING_ENRICHED_SCHEMA_SUCCEEDED,
  UPDATING_ENRICHED_SCHEMA_FAILED,
  SET_CURRENT_ENRICHED_SCHEMA,
  UNSET_CURRENT_ENRICHED_SCHEMA,
  SET_CURRENT_ENRICHED_SCHEMA_DETAILS,
  UNSET_CURRENT_ENRICHED_SCHEMA_DETAILS,
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA,
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_SUCCEEDED,
  ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_FAILED,
  LOADING_CURRENT_ENRICHED_SCHEMA,
  GET_ENRICHED_SCHEMA,
  GET_ENRICHED_SCHEMA_KEYS,
  UPDATE_ENRICHED_SCHEMA_FILTERS,
  RESET_ENRICHED_SCHEMA_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import { Base64 } from 'js-base64';

const initialState = {
  getting: false,
  gettingPaginated: true,
  list: [],
  paginatedList: [],
  current: {},
  keys: {},
  currentDetails: {
    option: 'ITINERARY',
    isDefaultSchema: false,
    hasMovedToNextStep: false
  },
  filters: {
    searchInput: '',
    sortBy: 'schemaName',
    sortOrder: 'ASC',
    pageNo: 0,
    rowsPerPage: 10,
    totalCount: 0,
    displayActive: true,
    filterProductNames: [],
    filterProductCategories: []
  },
  isSchemaSaved: false,
  schemaSaveFailed: false,
  schemaSaveFailedMessage: '',
  activateOrDeactivateSucceeded: false,
  activateOrDeactivateFailed: false,
  activateOrDeactivateFailedMessage: '',
  error: {
    message: null,
    raw: null
  }
};

export default createReducer(initialState, {
  [GET_ENRICHED_SCHEMAS]: state => {
    state.activateOrDeactivateSucceeded = false;
    state.activateOrDeactivateFailed = false;
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    state.activateOrDeactivateFailedMessage = '';
    state.error = {};
    state.getting = true;
    return state;
  },
  [GET_PAGINATED_ENRICHED_SCHEMAS]: state => {
    state.activateOrDeactivateSucceeded = false;
    state.activateOrDeactivateFailed = false;
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    state.activateOrDeactivateFailedMessage = '';
    state.error = {};
    state.gettingPaginated = true;
    return state;
  },
  [GETTING_ENRICHED_SCHEMAS_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.list = action.payload;
    return state;
  },
  [GETTING_PAGINATED_ENRICHED_SCHEMAS_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload;
    return state;
  },
  [GETTING_ENRICHED_SCHEMAS_FAILED]: (state, action) => {
    state.getting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_PAGINATED_ENRICHED_SCHEMAS_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_ENRICHED_SCHEMA]: state => {
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    state.error = {};
    state.getting = true;
    return state;
  },
  [GETTING_ENRICHED_SCHEMA_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.current = {
      ...action.payload,
      examplePayload:
        action.payload.examplePayload && action.payload.examplePayload !== ''
          ? Base64.decode(action.payload.examplePayload)
          : action.payload.examplePayload
    };
    return state;
  },
  [GETTING_ENRICHED_SCHEMA_FAILED]: (state, action) => {
    state.getting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_ENRICHED_SCHEMA_KEYS]: state => {
    state.getting = true;
    return state;
  },
  [GETTING_ENRICHED_SCHEMA_KEYS_SUCCEEDED]: (state, action) => {
    state.keys = action.payload.properties;
    state.getting = false;
    return state;
  },
  [GETTING_ENRICHED_SCHEMA_KEYS_FAILED]: (state, action) => {
    state.getting = false;
    state.keys = {};
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATE_ENRICHED_SCHEMA]: (state, action) => {
    state.current = {
      ...action.payload.schema,
      examplePayload:
        action.payload.schema.examplePayload !== ''
          ? Base64.encode(action.payload.schema.examplePayload)
          : action.payload.schema.examplePayload
    };
    state.isSchemaSaved = false;
    state.schemaSaveFailed = false;
    return state;
  },
  [CREATING_ENRICHED_SCHEMA_SUCCEEDED]: (state, action) => {
    state.current = { ...action.payload };
    state.isSchemaSaved = true;
    return state;
  },
  [CREATING_ENRICHED_SCHEMA_FAILED]: (state, action) => {
    state.schemaSaveFailed = true;
    state.schemaSaveFailedMessage = action.payload.isValidationFailed
      ? 'Please correct the above issues to save this schema.'
      : 'Unable to save the schema. Please check and try again.';
    state.isSchemaSaved = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    if (!action.payload.isValidationFailed) {
      state.current = {
        ...state.current,
        examplePayload:
          state.current.examplePayload !== ''
            ? Base64.decode(state.current.examplePayload)
            : state.current.examplePayload
      };
    }
    return state;
  },
  [UPDATE_ENRICHED_SCHEMA]: (state, action) => {
    state.current = {
      ...action.payload.schema,
      examplePayload:
        action.payload.schema.examplePayload !== ''
          ? Base64.encode(action.payload.schema.examplePayload)
          : action.payload.schema.examplePayload
    };
    return state;
  },
  [UPDATING_ENRICHED_SCHEMA_SUCCEEDED]: (state, action) => {
    state.current = { ...action.payload };
    state.isSchemaSaved = true;
    return state;
  },
  [UPDATING_ENRICHED_SCHEMA_FAILED]: (state, action) => {
    state.schemaSaveFailed = true;
    state.schemaSaveFailedMessage = action.payload.isValidationFailed
      ? 'Please correct the above issues to save this schema.'
      : 'Unable to save the schema. Please check and try again.';
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    if (!action.payload.isValidationFailed) {
      state.current = {
        ...state.current,
        examplePayload:
          state.current.examplePayload !== ''
            ? Base64.decode(state.current.examplePayload)
            : state.current.examplePayload
      };
    }
    return state;
  },
  [SET_CURRENT_ENRICHED_SCHEMA]: (state, action) => {
    state.current = {
      ...action.payload
    };
    return state;
  },
  [UNSET_CURRENT_ENRICHED_SCHEMA]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [SET_CURRENT_ENRICHED_SCHEMA_DETAILS]: (state, action) => {
    state.currentDetails = { ...action.payload };
    return state;
  },
  [UNSET_CURRENT_ENRICHED_SCHEMA_DETAILS]: state => {
    state.currentDetails = { ...initialState.currentDetails };
    return state;
  },
  [ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA]: state => {
    state.activateOrDeactivateSucceeded = false;
    state.activateOrDeactivateFailed = false;
    state.activateOrDeactivateFailedMessage = '';
    return state;
  },
  [ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_SUCCEEDED]: (state, action) => {
    state.activateOrDeactivateSucceeded = action.payload;
    return state;
  },
  [ACTIVATE_OR_DEACTIVATE_ENRICHED_SCHEMA_FAILED]: (state, action) => {
    state.activateOrDeactivateFailedMessage = action.payload.activeStatus
      ? 'Unable to archive schema. Please check and try again.'
      : 'Unable to activate schema. Please check and try again.';
    state.activateOrDeactivateFailed = true;
  },
  [LOADING_CURRENT_ENRICHED_SCHEMA]: state => {
    state.schemaSaveFailed = false;
    return state;
  },
   [UPDATE_ENRICHED_SCHEMA_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_ENRICHED_SCHEMA_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = { ...initialState.filters };
    return state;
  }
});
